<template>
	<div id="pointquery">
		<!-- 点位查询板块 -->
		<div class="title">分区查询</div>
		<div class="but">
			<div class="but_1" @click="handelclick_1">
				<div class="but_yuan">
					<div :class="isclick_1?'but_change_1':'but_yuan_1'">
					</div>

				</div>
			</div>
			<div class="but_2" @click="handelclick_2">
				<div class="but_yuan">
					<div :class="isclick_2?'but_change_1':'but_yuan_1'">
					</div>
				</div>
			</div>
		</div>
		<!-- 下方的搜索按钮与一些点位 -->
		<div class="dianwei">
			<p class="xian"></p>
			<div class="search">
				<div class="dian_pic"></div>
				<input type="text" placeholder="点位搜索" onfocus="if (placeholder =='点位搜索'){placeholder =''}" onblur="if (placeholder ==''){placeholder='点位搜索'}" class="search_input" v-model="searchvalue" />
			</div>
			<div class="dian_box" ref="scroll_3">
				<!-- 点位 -->
				<div class="dian_div_1">
					<div v-for="data in dataList" :key="data.water_device_code" class="dain_div_3" @click="dianclick(data.water_device_code)">
						<p>{{data.water_device_name}}</p>
						<div :class="[data.choose?'dian_choose_1':'dian_choose_2']"></div>
					</div>
				</div>
				<div class="custom-vertical-scrollbar" ref="vertical_3">
					<div class="custom-vertical-indicator"></div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
//	import axios from 'axios'
	import BScroll from 'better-scroll'
	import ScrollBar from '@better-scroll/scroll-bar'
	BScroll.use(ScrollBar)
	export default {
		data() {
			return {
				//给水，消防的选中状态
				isclick_1: false,
				isclick_2: true,
				//这个属性是一个去判断点位是否选中的一个存储上一个点位的变量
				accid: '',
				//搜索框下显示的点位信息
				data_1: [],
				//用于接收搜索框数据的双向绑定数据
				searchvalue: '',
				//这个是给水的点位信息
				data_2: [],
				//消防的点位信息
				data_3: [],
				//总的点位信息
				data_all: []
			}
		},
		computed: {
			//计算属性筛选出搜索的内容
			dataList() {
				return this.data_1.filter(item => item.water_device_name.includes(this.searchvalue))
			}
		},
		mounted() {
			this.getpointdata(); //获取数据
			//定时获取数据,一个小时
			setInterval(() => {
				this.getpointdata();
			}, 3600000)
		},
		methods: {
			//获取点位数据
			getpointdata() {
				//请求接口数据
				//设置请求参数
//				var params = new URLSearchParams();
//				params.append("deptId", "892");
//				params.append("checkCode", "3F55CAEAEAA1261CEFB7369CB6987DDB");
//				//发送请求
//				axios.post("/api/data/getDeviceInfo", params)
//					.then((res) => {
						//取出请求的数据
						this.data_1 =  [{
									"pma_value": "0.385",
									"water_device_code": "970850470",
									"water_sb_kj": "DN300",
									"water_device_zll": "26690.005",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "3.5",
									"water_device_name": "生活服务区总表"
								}, {
									"pma_value": "0.068",
									"water_device_code": "970850453",
									"water_sb_kj": "DN200",
									"water_device_zll": "17840.401",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "-4.7",
									"water_device_name": "实验楼外分区"
								}, {
									"pma_value": "0.071",
									"water_device_code": "970850468",
									"water_sb_kj": "DN200",
									"water_device_zll": "15408.6",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "-7.7",
									"water_device_name": "教学行政区总表"
								}, {
									"pma_value": "0.008",
									"water_device_code": "970850465",
									"water_sb_kj": "DN200",
									"water_device_zll": "1545.1",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "勤学楼外分区"
								}, {
									"pma_value": "0.061",
									"water_device_code": "970850443",
									"water_sb_kj": "DN200",
									"water_device_zll": "9874.7",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "-3.5",
									"water_device_name": "砺学楼外分区"
								}, {
									"pma_value": "0.397",
									"water_device_code": "970850467",
									"water_sb_kj": "DN200",
									"water_device_zll": "21586.201",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "7",
									"water_device_sjll": "1.2",
									"water_device_name": "宿舍区泵房"
								}, {
									"pma_value": "0.303",
									"water_device_code": "970850448",
									"water_sb_kj": "DN50",
									"water_device_zll": "118.4",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "战训楼"
								}, {
									"pma_value": "0.356",
									"water_device_code": "970850459",
									"water_sb_kj": "DN150",
									"water_device_zll": "7336.5",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "1.9",
									"water_device_name": "食堂"
								}, {
									"pma_value": "0.388",
									"water_device_code": "970850434",
									"water_sb_kj": "DN150",
									"water_device_zll": "2892.3",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "宿舍4栋"
								}, {
									"pma_value": "0.077",
									"water_device_code": "970850424",
									"water_sb_kj": "DN150",
									"water_device_zll": "5748.1",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "-4.2",
									"water_device_name": "战训基地"
								}, {
									"pma_value": "0.009",
									"water_device_code": "970850457",
									"water_sb_kj": "DN150",
									"water_device_zll": "8780.701",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "宿舍2栋"
								}, {
									"water_device_code": "970850430",
									"water_sb_kj": "DN100",
									"water_device_zll": "412.5",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "勤学楼"
								}, {
									"pma_value": "0.395",
									"water_device_code": "970850464",
									"water_sb_kj": "DN100",
									"water_device_zll": "5570.201",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "宿舍3栋"
								}, {
									"pma_value": "0.432",
									"water_device_code": "970850449",
									"water_sb_kj": "DN100",
									"water_device_zll": "1094.501",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "行政楼泵房"
								}, {
									"pma_value": "0.4",
									"water_device_code": "970850460",
									"water_sb_kj": "DN100",
									"water_device_zll": "4020.901",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "宿舍1栋"
								}, {
									"pma_value": "0.012",
									"water_device_code": "970850469",
									"water_sb_kj": "DN100",
									"water_device_zll": "924.701",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "礼堂右侧消防"
								}, {
									"pma_value": "0.062",
									"water_device_code": "970850447",
									"water_sb_kj": "DN100",
									"water_device_zll": "176.6",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "砺学楼"
								}, {
									"pma_value": "0.063",
									"water_device_code": "970850437",
									"water_sb_kj": "DN80",
									"water_device_zll": "240.2",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "实验楼"
								}, {
									"pma_value": "0.058",
									"water_device_code": "970850436",
									"water_sb_kj": "DN80",
									"water_device_zll": "209.201",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "图书馆"
								}, {
									"water_device_code": "970850425",
									"water_sb_kj": "DN50",
									"water_device_zll": "455.801",
									"water_gd_cz": "PPR",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "清雅湖边上绿化"
								}, {
									"water_device_code": "970850456",
									"water_sb_kj": "DN100",
									"water_device_zll": "3306.9",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "礼堂左侧消防"
								}, {
									"water_device_code": "868528348",
									"water_sb_kj": "DN150",
									"water_device_zll": "143.801",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "6",
									"water_device_sjll": "0",
									"water_device_name": "礼堂"
								}, {
									"water_device_code": "970850426",
									"water_sb_kj": "DN50",
									"water_device_zll": "503",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "西门门岗及绿化"
								}, {
									"water_device_code": "970850428",
									"water_sb_kj": "DN50",
									"water_device_zll": "34.501",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "砺学楼绿化"
								}, {
									"water_device_code": "970850438",
									"water_sb_kj": "DN50",
									"water_device_zll": "64.801",
									"water_gd_cz": "PPR",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0.4",
									"water_device_name": "行政楼绿化"
								}, {
									"water_device_code": "970850458",
									"water_sb_kj": "DN100",
									"water_device_zll": "3.4",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "10",
									"water_device_sjll": "0",
									"water_device_name": "宿舍区绿化"
								}, {
									"water_device_code": "990804305",
									"water_sb_kj": "DN150",
									"water_device_zll": "705.1",
									"water_gd_cz": "PE",
									"choose": false,
									"online_type": "在线",
									"water_device_signal": "6",
									"water_device_sjll": "0",
									"water_device_name": "行政楼"
								}];
							
						//将请求到的数据放到vex中，这个会传到3d模型中
						this.$store.commit('getpointdata', this.data_1)
						this.data_all = this.data_1;
						//因为这个接口包含了给水，消防的点位信息，这里进行一下分类
						this.data_1.forEach(item => {
							if(item.water_device_name.includes('消防')) {
								//消防的点位信息，push进入data_2
								this.data_2.push(item)
							} else {
								//剩余的给水点位，进入data_3
								this.data_3.push(item)
							}
						})
						//因为给水点位的初始状态为选中，所以这里将data_3赋值给data_1用于显示
						this.data_1 = this.data_3;

						setTimeout(() => {
							this.$nextTick(() => {
								new BScroll(this.$refs.scroll_3, {
									scrollX: false,
									scrollY: true,
									click: true,
									mouseWheel: true,
									scrollbar: {
										customElements: [this.$refs.vertical_3],
										fade: true,
										interactive: true,
										scrollbarTrackClickable: true
									}
								})
							})
						}, 300)
//					})
//					//捕获错误信息并打印
//					.catch((error) => {
//						console.log(error);
//					});
			},
			//给水按钮的选中逻辑
			handelclick_1() {
				//this.$forceUpdate();

				//判断当前是否选中，选中进入if判断，将值赋反
				if(this.isclick_2) {
					this.isclick_1 = !this.isclick_1;

				}
				//如果没有选中进入else分支
				else {
					//这里做的是将如果一个选中，然后去选另一个的时候，会把前一个的给取消选中状态
					this.isclick_1 = !this.isclick_1
					this.isclick_2 = !this.isclick_2
				}

				//这个判断条件为将data_3的数据给到data_1，也就是将给水的点位赋值data_1
				if(this.isclick_2) {
					this.data_1 = this.data_3
				}

				//这里是如果给水，消防按钮都没有选中，那么则将显示所有的点位信息,data_all
				if(this.isclick_1 && this.isclick_2) {
					this.data_1 = this.data_all
				}

			},
			//消防按钮的选中逻辑
			handelclick_2() {
				// this.$forceUpdate();
				if(this.isclick_1) {
					this.isclick_2 = !this.isclick_2;
				} else {
					this.isclick_1 = !this.isclick_1
					this.isclick_2 = !this.isclick_2
				}

				if(this.isclick_1) {
					this.data_1 = this.data_2
				}

				if(this.isclick_1 && this.isclick_2) {
					this.data_1 = this.data_all
				}

			},

			//点位搜索的选中逻辑
			dianclick(id) {
				//定义一个临时变量存储点击后传入的id
				var temid = id;
				this.data_all.forEach(item => {
					//如果这个有data_2的water_device_code与传入id相等，说明要选中的就是这个点位，于是将choose给赋值为true
					if(item.water_device_code == id) {
						item.choose = true;
						//这个if是判断如果前后两次的id相等，则会把这个id的choose值赋值为false，并把保存传入id的临时变量temid赋值为空
						if(this.accid == id) {
							item.choose = false;
							temid = '';
						}
					} else {
						item.choose = false;
					}
				})
				//最后则是把临时temid的值赋给accid，accid用于保存上次传入的id信息
				this.accid = temid;

				this.data_1.forEach(item => {
					if(item.water_device_code == id) {
						if(item.choose) {
							//调用3d模型
							document.getElementById('iframe').contentWindow.MMAPI.pointquery(id, this.$store.getters.f_PointData, item.choose);
							if(this.$store.state.watchisshow) {
								this.$store.commit('changewatchshow_1')
							}
						} else {
							//调用3d模型
							document.getElementById('iframe').contentWindow.MMAPI.pointquery(id, this.$store.getters.f_PointData, item.choose);
						}
					}
				})
				this.$store.commit("environmentchange_1");
				this.$store.commit("changepressbut_1");
			}

		}
	}
</script>

<style scoped>
	#pointquery {
		width: 100%;
		height: 20.74vh;
		background: url("@/assets/pengshui_bg.png") no-repeat center center;
		color: #ffffff;
		background-size: 100% 100%;
	}
	
	.title {
		height: 4.53vh;
		/* border: 1px solid red; */
		font-size: 18px;
		line-height: 4.53vh;
		text-align: start;
		margin-left: 20px;
	}
	
	.but {
		height: 4.44vh;
		width: 100%;
		/* border: 1px solid red; */
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		position: absolute;
	}
	
	.but_1,
	.but_2 {
		width: 7.29vw;
		height: 4.44vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		/* line-height: 4.62vh; */
		/* position: absolute; */
	}
	
	.but_1 {
		background: url("@/assets/pengshui_14.png") no-repeat center center;
		background-size: 100% 100%;
		position: relative;
		/* left: 20px; */
	}
	
	.but_2 {
		background: url("@/assets/pengshui_15.png") no-repeat center center;
		background-size: 100% 100%;
		position: relative;
	}
	
	.but_p {
		transform: translateY(0.8vh);
		font-size: 8px !important;
		text-align: center;
		transform: scale(0.8);
		width: 100%;
		/* width: 70%; */
	}
	
	.but_p_1 {
		font-size: 8px !important;
		text-align: start;
		transform: translateX(1.19vw) scale(0.8);
		width: 60%;
	}
	
	.dianwei {
		height: 12vh;
		position: relative;
		top: 4.17vh;
		left: 0;
		/* left: 10px; */
	}
	
	.xian {
		margin-top: 0.9vh;
		height: 0.27vh;
		width: 85%;
		background: url("@/assets/pengshui_16.png") no-repeat center center;
		background-size: 100% 100%;
	}
	
	.dian_box {
		height: 6.67vh;
		width: 90%;
		overflow: hidden;
		position: relative;
		cursor: pointer;
	}
	
	.dian_div_1 {
		margin-top: 0.3vh;
		display: flex;
		width: 90%;
		justify-content: space-between;
		flex-wrap: wrap;
		font-size: 10px;
		text-align: center;
		color: #b0b7c2;
	}
	
	.dain_div_3 {
		display: flex;
		height: 2vh;
		width: 45%;
		justify-content: space-between;
		align-items: center;
		/* width: 50%; */
		margin-top: 0.46vh;
		cursor: pointer;
	}
	
	.search {
		margin-top: 0.7vh;
		width: 83%;
		height: 1.85vh;
		border: 1px solid #b0b7c2;
		font-size: 12px;
		text-align: start;
		/* position: absolute; */
		color: #5e667c;
		line-height: 1.85vh;
		position: relative;
	}
	
	.search_input {
		height: 1.85vh;
		width: 98%;
		padding-left: 0.26vw;
		line-height: 1.85vh;
		background: #000a2b;
		border: none;
		color: #b0b7c2;
	}
	
	.dian_pic {
		position: absolute;
		background: url("@/assets/pengshui_17.png") no-repeat center center;
		background-size: 100% 100%;
		width: 10px;
		height: 10px;
		right: 3%;
		top: 20%;
	}
	
	.but_yuan_1 {
		width: 12px;
		height: 12px;
		border: none;
		position: absolute;
		top: 10%;
		right: 5%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: url("@/assets/pengshui_yuan.png") no-repeat center center;
		background-size: 100% 100%;
	}
	
	.but_change_1 {
		border: none;
		width: 12px;
		height: 12px;
		position: absolute;
		top: 10%;
		right: 5%;
		background: url("@/assets/pengshui_yuan_1.png") no-repeat center center;
		background-size: 100% 100%;
	}
	
	.dian_div {
		position: relative;
	}
	
	.dian_choose_1 {
		/* flex: 1; */
		width: 12px;
		height: 12px;
		border: none;
		background: url("@/assets/pengshui_yuan.png") no-repeat center center;
		background-size: 100% 100%;
	}
	
	.dian_choose_2 {
		/* flex: 1; */
		width: 12px;
		height: 12px;
		border: none;
		background: url("@/assets/pengshui_yuan_1.png") no-repeat center center;
		background-size: 100% 100%;
	}
	
	.custom-vertical-scrollbar {
		position: absolute;
		top: 50%;
		right: .0625rem;
		height: 3.75rem;
		width: .4375rem;
		border-radius: .375rem;
		transform: translateY(-50%) translateZ(0);
		background-color: rgb(200, 200, 200, 0.3);
		z-index: 10;
	}
</style>